import { Component } from '@angular/core';

@Component({
  selector: 'app-medicamentos-reponer',
  templateUrl: './medicamentos-reponer.component.html',
  styleUrls: ['./medicamentos-reponer.component.css']
})
export class MedicamentosReponerComponent {}
